import axios from 'axios';
import { HTTP_CODES } from '@/constants/http';
import logger from '@/utils/logger';

/**
 * Фабрика http-сервиса
 *
 * @param {Object} httpConfig
 * @returns {Object}
 */
export default function factoryHttp(httpConfig = {}) {
  const axiosConfig = {
    baseURL: '',
    ...httpConfig,
  };
  const axiosInstance = axios.create({
    baseURL: axiosConfig.baseURL,
  });

  /**
   * Методы для работы с http с обработкой ошибок и ответа
   */
  return {
    /**
     * @returns {AxiosInstance}
     */
    getInstance() {
      return axiosInstance;
    },

    /**
     * Обертка произвольного запроса
     * Чистый запрос без обработчиков
     *
     * @param {Object} config
     * @returns {Promise<*>}
     */
    async request(config) {
      try {
        return await axiosInstance.request(config);
      } catch (error) {
        logger.exception(error);
        return false;
      }
    },

    /**
     * ...
     *
     * @param {string} url
     * @param {Object} params - query параметры
     * @param {Object} config
     * @returns {Promise<Object>}
     */
    async get(url, params = null, config = {}) {
      try {
        const requestConfig = {
          ...config,
          ...{
            method: 'get',
            url,
            params,
          },
        };
        const response = await axiosInstance.request(requestConfig);
        const { status, errors, data } = response;

        if (status !== HTTP_CODES.OK) {
          logger.error(`get: server status code: ${status}`);
          return false;
        }
        if (errors) {
          logger.error('get: errors', errors);
          return false;
        }
        if (!data) {
          logger.error('get: data is not found!');
          return false;
        }
        if (data.errors?.length) {
          logger.error('get: data errors', data.errors);
          return { errors: data.errors };
        }
        if (typeof data.data === 'undefined') {
          logger.error('get: property "data" is not found!');
          return false;
        }

        return data;
      } catch (error) {
        logger.exception(error);
        return false;
      }
    },

    /**
     * ...
     *
     * @param {string} url
     * @param {Object} params
     * @param {Object} config
     * @returns {Promise<Object>}
     */
    async post(url, params, config = {}) {
      try {
        const requestConfig = {
          ...config,
          ...{
            method: 'post',
            url,
            data: params,
          },
        };
        const response = await axiosInstance.request(requestConfig);
        const { status, errors, data } = response;

        if (status !== HTTP_CODES.OK) {
          logger.error(`post: server status code: ${status}`);
          return false;
        }
        if (errors) {
          logger.error('post: errors', errors);
          return false;
        }
        if (!data) {
          logger.error('post: data is not found!');
          return false;
        }
        if (data.errors?.length) {
          logger.error('post: data errors', data.errors);
          return { errors: data.errors };
        }
        if (typeof data.data === 'undefined') {
          logger.error('post: property "data" is not found!');
          return false;
        }
        if (typeof data.meta === 'undefined') {
          logger.error('post: property "meta" is not found!');
          return false;
        }

        return data;
      } catch (error) {
        logger.exception(error);
        return false;
      }
    },

    /**
     * ...
     *
     * @param {string} url
     * @param {Object} params
     * @param {Object} config
     * @returns {Promise<Object>}
     */
    async put(url, params, config = {}) {
      try {
        const requestConfig = {
          ...config,
          ...{
            method: 'put',
            url,
            data: params,
          },
        };
        const response = await axiosInstance.request(requestConfig);
        const { status, errors, data } = response;

        if (status !== HTTP_CODES.OK) {
          logger.error(`put: server status code: ${status}`);
          return false;
        }
        if (errors) {
          logger.error('put: errors', errors);
          return false;
        }
        if (!data) {
          logger.error('put: data is not found!');
          return false;
        }
        if (data.errors?.length) {
          logger.error('put: data errors', data.errors);
          return { errors: data.errors };
        }
        if (typeof data.data === 'undefined') {
          logger.error('put: property "data" is not found!');
          return false;
        }
        // if (typeof data.meta === 'undefined') {
        //   logger.error('put: property "meta" is not found!');
        //   return false;
        // }

        return data;
      } catch (error) {
        logger.exception(error);
        return false;
      }
    },

    /**
     * ...
     *
     * @param {string} url
     * @param {Object} config
     * @returns {Promise<Object>}
     */
    async delete(url, config = {}) {
      try {
        const requestConfig = {
          ...config,
          ...{
            method: 'delete',
            url,
          },
        };
        const response = await axiosInstance.request(requestConfig);
        const { status, errors, data } = response;

        if (status !== HTTP_CODES.OK) {
          logger.error(`delete: server status code: ${status}`);
          return false;
        }
        if (errors) {
          logger.error('delete: errors', errors);
          return false;
        }
        if (!data) {
          logger.error('delete: data is not found!');
          return false;
        }
        if (data.errors?.length) {
          logger.error('delete: data errors', data.errors);
          return { errors: data.errors };
        }
        if (typeof data.meta === 'undefined') {
          logger.error('delete: property "meta" is not found!');
          return false;
        }

        return data;
      } catch (error) {
        logger.exception(error);
        return false;
      }
    },
  };
}
